"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.isMorningStarPresent = isMorningStarPresent;
exports.isMorningStarAnalystRatingPresent = isMorningStarAnalystRatingPresent;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _fund_awards = require("./fund_awards");

var _fund_awards2 = _interopRequireDefault(_fund_awards);

var _hocMorningstarRatings = require("../hoc/cards/hocMorningstarRatings");

var _summary_header_morning_star = require("./summary_header_morning_star");

var _summary_header_morning_star2 = _interopRequireDefault(_summary_header_morning_star);

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _hocAnalystRating = require("../hoc/cards/hocAnalystRating");

var _analyst_rating = require("./analyst_rating");

var _analyst_rating2 = _interopRequireDefault(_analyst_rating);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _summary_header_performance_ratings = require("./summary_header_performance_ratings");

var _summary_header_performance_ratings2 = _interopRequireDefault(_summary_header_performance_ratings);

var _functional_utility2 = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isMorningStarPresent(shareClass, props) {
  var result = false;
  if ((0, _functional_utility.doesVisibleDataPointContains)("HIDE_MORNINGSTAR_RATING", props)) {
    return result;
  }
  var morningstarRating = shareClass.morningstarRating;

  for (var i = 0; morningstarRating && i < morningstarRating.length; i++) {
    if ((morningstarRating[i].periodIndicator === 'OVR' || (0, _functional_utility.doesVisibleDataPointContains)('SHOW_MORNINGSTAR_RATING', props)) && morningstarRating[i].rankNumber > 3) {
      result = true;
      break;
    } else if ((0, _functional_utility.doesVisibleDataPointContains)('SHOW_MORNINGSTAR_RATING_ALWAYS', props) && morningstarRating[i].rankNumber > 0) {
      result = true;
      break;
    }
  }
  return result;
}

function isMorningStarAnalystRatingPresent(shareClass, props) {
  var result = true;
  if ((0, _functional_utility.doesVisibleDataPointContains)("HIDE_ANALYST_RATING", props)) {
    return false;
  }
  var morningstarOverallRating = shareClass.morningstarOverallRating;

  var medalistRatingIndicator = _constants2.default.getMedalistRatingIndicator((0, _ramda.pathOr)(null, ["morningstarMedalistRatingIndicator"], morningstarOverallRating));
  if ((0, _ramda.isNil)(morningstarOverallRating) || (0, _ramda.isNil)(morningstarOverallRating.morningstarMedalistRatingIndicator) || (0, _ramda.isNil)(medalistRatingIndicator)) {
    result = false;
  }
  return result;
}

var AwardsAndRatings = function (_PureComponent) {
  _inherits(AwardsAndRatings, _PureComponent);

  function AwardsAndRatings(props) {
    _classCallCheck(this, AwardsAndRatings);

    return _possibleConstructorReturn(this, (AwardsAndRatings.__proto__ || Object.getPrototypeOf(AwardsAndRatings)).call(this, props));
  }

  _createClass(AwardsAndRatings, [{
    key: "renderFundAwards",
    value: function renderFundAwards(childWidth) {
      var _props = this.props,
          breakpoint = _props.breakpoint,
          fund = _props.fund,
          tooltip = _props.tooltip;

      if ((0, _functional_utility2.isNilOrEmpty)(fund.fundAwards) || !(0, _functional_utility.doesVisibleDataPointContains)("SHOW_AWARDS_AND_RATINGS", this.props)) {
        return null;
      }
      return _react2.default.createElement(_fund_awards2.default, {
        fundAwards: fund.fundAwards,
        disclosure: fund.disclosures,
        breakpoint: breakpoint,
        tooltip: tooltip,
        childWidth: childWidth,
        formattingRules: fund.visibleData.formattingRules,
        visibleDataPoints: fund.visibleData.visibleDataPoints
      });
    }
  }, {
    key: "renderMorningStarRating",
    value: function renderMorningStarRating(widthStyle) {
      if (!isMorningStarPresent(this.props.fund.shareClass, this.props)) {
        return null;
      }
      var _props2 = this.props,
          breakpoint = _props2.breakpoint,
          fund = _props2.fund,
          tooltip = _props2.tooltip;

      var morningstarSummaryHeaderProps = (0, _hocMorningstarRatings.getDefaultMorningstarProps)({ fund: fund, breakpoint: breakpoint });
      if ((0, _functional_utility.doesVisibleDataPointContains)("MAP_PEER_GROUP_CATEGORY_TO_MSTAR_CATEGORY", this.props)) {
        morningstarSummaryHeaderProps.additionalClassName = breakpoint > 3 ? "margin-bottom-15" : "";
      }
      return _react2.default.createElement(
        "div",
        { className: "flex-Child " + widthStyle },
        _react2.default.createElement(_summary_header_morning_star2.default, _extends({}, morningstarSummaryHeaderProps, {
          tooltip: tooltip,
          role: this.props.role,
          intl: this.props.intl
        }))
      );
    }
  }, {
    key: "renderMorningstarAnalystRating",
    value: function renderMorningstarAnalystRating(widthStyle) {
      var _props3 = this.props,
          breakpoint = _props3.breakpoint,
          tooltip = _props3.tooltip,
          fund = _props3.fund,
          gaiaRedirectUrl = _props3.gaiaRedirectUrl;


      var morningstarAnalystRatingProps = (0, _hocAnalystRating.getDefaultAnalystRatingProps)({ fund: fund, breakpoint: breakpoint, gaiaRedirectUrl: gaiaRedirectUrl });
      if ((0, _functional_utility.doesVisibleDataPointContains)("MAP_PEER_GROUP_CATEGORY_TO_MSTAR_CATEGORY", this.props)) {
        morningstarAnalystRatingProps.additionalClassName = "margin-bottom-15";
      }

      return _react2.default.createElement(
        "div",
        { className: "flex-Child " + widthStyle },
        _react2.default.createElement(_analyst_rating2.default, _extends({}, morningstarAnalystRatingProps, {
          tooltip: tooltip,
          role: this.props.role,
          intl: this.props.intl,
          visibleData: this.props.fund.visibleData,
          fund: this.props.fund
        }))
      );
    }
  }, {
    key: "renderSummaryHeaderPerformanceRatings",
    value: function renderSummaryHeaderPerformanceRatings(numberOfItemsToShow, widthPercent) {
      var _props4 = this.props,
          fund = _props4.fund,
          breakpoint = _props4.breakpoint,
          gaiaRedirectUrl = _props4.gaiaRedirectUrl,
          tooltip = _props4.tooltip,
          additionalRatingsHandler = _props4.additionalRatingsHandler;

      var fundPerformanceRatings = (0, _functional_utility2.isNilOrEmpty)(fund.fundPerformanceRatings) ? null : (0, _ramda.filter)((0, _ramda.propEq)('isAward', false), fund.fundPerformanceRatings);

      if (!(0, _ramda.isNil)(fundPerformanceRatings) && numberOfItemsToShow <= fundPerformanceRatings.length) {
        var additionalRatings = fundPerformanceRatings.slice(numberOfItemsToShow < 0 ? 1 : numberOfItemsToShow);
        if ((0, _ramda.isNil)(this.props.additionalRatings) || this.props.additionalRatings.length !== additionalRatings.length) {
          additionalRatingsHandler(additionalRatings);
        }
      } else if (!(0, _ramda.isNil)(this.props.additionalRatings)) {
        additionalRatingsHandler(null);
      }

      return _react2.default.createElement(_summary_header_performance_ratings2.default, {
        role: this.props.role,
        numberOfItemsToShow: numberOfItemsToShow,
        gaiaRedirectUrl: gaiaRedirectUrl,
        disclosure: fund.disclosures,
        breakpoint: breakpoint,
        tooltip: tooltip,
        performanceRatingWidthPercentage: widthPercent,
        fundPerformanceRatings: fundPerformanceRatings,
        visibleData: this.props.fund.visibleData });
    }
  }, {
    key: "renderPerformanceRatings",
    value: function renderPerformanceRatings(childWidth) {
      var _props5 = this.props,
          breakpoint = _props5.breakpoint,
          fund = _props5.fund;


      var emeaAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props);
      var auRatings = (0, _functional_utility.doesFormattingRulesContain)("RATING_ALIGNMENT_AU", this.props);
      var performanceRatingsColClassName = "col-md-12 col-lg-12 padding-left-0";
      var numberOfPerformanceRatingsToShow = 4;
      var maxSummaryRatingsToShow = 2;

      if (breakpoint > 4) {
        maxSummaryRatingsToShow = 4;
      } else if (breakpoint < 3) {
        maxSummaryRatingsToShow = 0;
      }

      if (auRatings) {
        maxSummaryRatingsToShow = 2;
      }

      if (!(0, _ramda.isNil)(fund.fundPerformanceRatings) && fund.fundPerformanceRatings.length > 0) {

        if ((0, _ramda.and)(isMorningStarAnalystRatingPresent(this.props.fund.shareClass, this.props), isMorningStarPresent(this.props.fund.shareClass, this.props))) {
          maxSummaryRatingsToShow -= 2;
        } else if ((0, _ramda.or)(isMorningStarAnalystRatingPresent(this.props.fund.shareClass, this.props), isMorningStarPresent(this.props.fund.shareClass, this.props))) {
          maxSummaryRatingsToShow -= 1;
        }

        numberOfPerformanceRatingsToShow = fund.fundPerformanceRatings.length > maxSummaryRatingsToShow ? maxSummaryRatingsToShow : fund.fundPerformanceRatings.length;
        performanceRatingsColClassName = "flex-parent";
      }

      var shouldRenderSummaryHeaderPerformanceRatings = (0, _ramda.and)(breakpoint > 2, (0, _functional_utility.doesVisibleDataPointContains)("SHOW_PERFORMANCE_RATINGS", this.props));

      var performanceRatingWidthPercentage = "";
      if (numberOfPerformanceRatingsToShow > 0) {
        performanceRatingWidthPercentage = emeaAlignment ? "width-percent-" + childWidth : "width-percent-" + Math.floor(1 * 100 / numberOfPerformanceRatingsToShow);
      }
      if (auRatings) {
        shouldRenderSummaryHeaderPerformanceRatings = true;
        if (breakpoint < 4) {
          performanceRatingWidthPercentage = "width-percent-100";
        }
      }

      return shouldRenderSummaryHeaderPerformanceRatings && (emeaAlignment ? _react2.default.createElement(
        _react.Fragment,
        null,
        this.renderSummaryHeaderPerformanceRatings(numberOfPerformanceRatingsToShow, performanceRatingWidthPercentage)
      ) : _react2.default.createElement(
        "div",
        { className: "width-percent-" + numberOfPerformanceRatingsToShow * childWidth },
        _react2.default.createElement(
          "div",
          { className: performanceRatingsColClassName },
          this.renderSummaryHeaderPerformanceRatings(numberOfPerformanceRatingsToShow, performanceRatingWidthPercentage)
        )
      ));
    }
  }, {
    key: "render",
    value: function render() {
      var _props6 = this.props,
          breakpoint = _props6.breakpoint,
          fund = _props6.fund;

      var containerClassName = 'col-xs-12 col-md-12 col-lg-12 col-xlg-12 flex-container margin-all-0 empty-div ';
      var maxperformanceRatingsToShow = void 0;
      var emeaAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props);
      var auRatings = (0, _functional_utility.doesFormattingRulesContain)("RATING_ALIGNMENT_AU", this.props);
      if (auRatings) {
        containerClassName = 'col-xs-12 col-md-12 col-lg-12 col-xlg-12 margin-all-0 empty-div ';
      }

      switch (breakpoint) {
        case 1:
        case 2:
          {
            var custHKStyle = breakpoint === 1 ? '' : 'padding-left-10';
            var custStyle = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_AWARDS_AND_RATINGS", this.props) ? custHKStyle : "";
            containerClassName += 'padding-top-20 ';
            containerClassName += custStyle;
            maxperformanceRatingsToShow = 0;
            break;
          }
        case 3:
          {
            containerClassName += 'padding-bottom-15';
            maxperformanceRatingsToShow = 2;
            break;
          }
        case 4:
          {
            maxperformanceRatingsToShow = 2;
            break;
          }
        default:
          {
            maxperformanceRatingsToShow = emeaAlignment ? 3 : 4;
          }
      }
      var fundAwardsQty = (0, _ramda.and)(!(0, _ramda.isNil)(fund.fundAwards), (0, _functional_utility.doesVisibleDataPointContains)("SHOW_AWARDS_AND_RATINGS", this.props)) ? (0, _ramda.length)(fund.fundAwards) : 0;
      var morningstarRatingQty = isMorningStarPresent(this.props.fund.shareClass, this.props) ? 1 : 0;
      var morningstarAnalystRatingQty = isMorningStarAnalystRatingPresent(this.props.fund.shareClass, this.props) ? 1 : 0;

      maxperformanceRatingsToShow = maxperformanceRatingsToShow - morningstarRatingQty - morningstarAnalystRatingQty;

      var performanceRatingsQty = !(0, _ramda.isNil)(fund.fundPerformanceRatings) ? fund.fundPerformanceRatings.length : 0;
      performanceRatingsQty = performanceRatingsQty >= maxperformanceRatingsToShow ? maxperformanceRatingsToShow : performanceRatingsQty;
      performanceRatingsQty = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_PERFORMANCE_RATINGS", this.props) ? performanceRatingsQty : 0;

      var totalQty = (emeaAlignment ? morningstarRatingQty : 0) + fundAwardsQty + morningstarAnalystRatingQty + performanceRatingsQty;
      var childWidth = Math.floor(100 / totalQty);
      var childWidthForMorningStarRating = emeaAlignment ? "width-percent-" + childWidth : 'width-percent-100';
      var childWidthForMorningStarMedalist = childWidth;
      if (auRatings) {
        childWidthForMorningStarRating = 'width-percent-100';
      }

      var apacAwardMstarAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_APAC", this.props);
      if (apacAwardMstarAlignment && morningstarAnalystRatingQty > 0) {
        childWidth = breakpoint < 3 ? 100 : 50;
        childWidthForMorningStarRating = 'width-percent-' + childWidth;
        childWidthForMorningStarMedalist = childWidth;
      }
      var emeaAwardMstarAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props);
      if (emeaAwardMstarAlignment && morningstarAnalystRatingQty > 0) {
        childWidthForMorningStarRating = breakpoint < 4 ? 'width-percent-' + 100 : 'width-percent-' + 40;
        childWidthForMorningStarMedalist = breakpoint < 4 ? 100 : 60;
      }

      return _react2.default.createElement(
        "div",
        { className: "" + containerClassName },
        morningstarRatingQty === 0 ? null : this.renderMorningStarRating(childWidthForMorningStarRating),
        morningstarAnalystRatingQty > 0 && this.renderMorningstarAnalystRating("width-percent-" + childWidthForMorningStarMedalist),
        this.renderFundAwards(childWidth),
        this.renderPerformanceRatings(childWidth)
      );
    }
  }]);

  return AwardsAndRatings;
}(_react.PureComponent);

exports.default = AwardsAndRatings;